import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { linksData } from '../mock';

const LinksPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-sky-600 to-green-600 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Helpful Resources & Links
          </h1>
          <p className="text-xl text-sky-50 max-w-3xl mx-auto">
            Professional affiliations, industry resources, and useful information
          </p>
        </div>
      </section>

      {/* Links Section */}
      <section className="py-20 bg-metallic-gold">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-8">
            {linksData.map((section) => (
              <Card key={section.category} className="border-2 border-sky-100 hover:shadow-lg transition-shadow">
                <CardHeader>
                  <CardTitle className="text-2xl text-sky-700">{section.category}</CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3">
                    {section.links.map((link) => (
                      <a
                        key={link.name}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-between p-4 bg-gradient-to-br from-sky-50 to-green-50 rounded-lg hover:shadow-md transition-all group border border-transparent hover:border-sky-200"
                      >
                        <span className="font-medium text-gray-800 group-hover:text-sky-600 transition-colors">
                          {link.name}
                        </span>
                        <ExternalLink className="w-5 h-5 text-gray-400 group-hover:text-sky-600 transition-colors" />
                      </a>
                    ))}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="py-20 bg-metallic-gold">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white border-2 border-sky-100 rounded-lg p-8 shadow-lg">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Stay Informed About Real Estate Appraisals
            </h2>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Understanding the appraisal process is crucial for homeowners, buyers, and real estate professionals. 
              These resources provide valuable information about industry standards, regulations, and best practices.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="p-4 bg-gradient-to-br from-sky-50 to-green-50 rounded-lg border border-sky-100">
                <h3 className="font-semibold text-gray-900 mb-2">Industry Standards</h3>
                <p className="text-sm text-gray-600">
                  All our appraisals comply with USPAP (Uniform Standards of Professional Appraisal Practice) guidelines.
                </p>
              </div>
              <div className="p-4 bg-gradient-to-br from-sky-50 to-green-50 rounded-lg border border-sky-100">
                <h3 className="font-semibold text-gray-900 mb-2">Continuing Education</h3>
                <p className="text-sm text-gray-600">
                  We maintain active Minnesota and Wisconsin certifications and stay current with industry developments.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LinksPage;